import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TipoPagamentoEcgTerceiro } from "./tipo-pagamento-ecg-terceiro";

export class LimitePagamentoEcgTerceiro extends BaseEntity {
  public tipoPagamentoEcgTerceiro: TipoPagamentoEcgTerceiro;
  public dataReferencia: Date;
  public comentarios: string;
  public valorLimiteTotal: number;
  public valorLimiteAnterior: number;

  public nomeTipoPagamentoEcgTerceiro: string;
  public valorDisponivel: number;
  public valorUtilizado: number;
  public nomeModalidade: string;
}
